export default __webpack_public_path__ + "static/media/Challenge.a55caf79.svg";